import { Controller } from '@hotwired/stimulus'
import * as bootstrap from 'bootstrap'

export default class ModalController extends Controller {
  static targets = [
    'modalContainer',
  ]

  static values = {
    autoShow: Boolean
  }

  initialize() {
    this.modal = new bootstrap.Modal(this.modalContainerTarget);
  }

  connect() {
    if (this.hasAutoShowValue && this.autoShowValue) {
      this.modal.show()
    }
  }
}
